// extracted by mini-css-extract-plugin
export var component = "post-module--component--2q741";
export var image = "post-module--image--Ao1yH";
export var category = "post-module--category--2b2fg";
export var title = "post-module--title--1i2dV";
export var info = "post-module--info--1EUL3";
export var hr = "post-module--hr--3OwOE";
export var index0 = "post-module--index0--3NSnx";
export var content = "post-module--content--3KtAE";